import { BASIC_INFO_LOAD, BASIC_INFO_LOAD_SUCCESS, BASIC_INFO_LOAD_FAIL, EDIT_ORDER_ADDRESS, EDIT_ORDER_ADDRESS_SUCCESS, EDIT_ORDER_ADDRESS_FAIL } from '../actions/driverTypes.js';
import { ORDER_INFO_LOAD, ORDER_INFO_LOAD_SUCCESS, ORDER_INFO_LOAD_FAIL } from '../actions/driverTypes.js';
import { ORDER_INFO_DETAIL_LOAD, ORDER_INFO_DETAIL_LOAD_SUCCESS, ORDER_INFO_DETAIL_LOAD_FAIL } from '../actions/driverTypes.js';
import { ORDER_INFO_UPDATE, ORDER_INFO_UPDATE_SUCCESS, ORDER_INFO_UPDATE_FAIL } from '../actions/driverTypes.js';

import { NEXT_TRANSITION_LOAD, NEXT_TRANSITION_LOAD_SUCCESS, NEXT_TRANSITION_LOAD_FAIL} from '../actions/driverTypes.js';
import { ORDER_SIGNATURE_PHOTO_LOAD, ORDER_SIGNATURE_PHOTO_LOAD_SUCCESS, ORDER_SIGNATURE_PHOTO_LOAD_FAIL} from '../actions/driverTypes.js';
import { ORDER_SIGNATURE_PHOTO_UPDATE, ORDER_SIGNATURE_PHOTO_UPDATE_SUCCESS, ORDER_SIGNATURE_PHOTO_UPDATE_FAIL} from '../actions/driverTypes.js'
import { INSERT_DRIVER_ORDER, INSERT_DRIVER_ORDER_SUCCESS, INSERT_DRIVER_ORDER_FAIL} from '../actions/driverTypes.js'
import { UPDATE_SCAN_STATUS, UPDATE_SCAN_STATUS_SUCCESS, UPDATE_SCAN_STATUS_FAIL} from '../actions/driverTypes.js'
import { CREATE_SECONDARY_DELIVERY, CREATE_SECONDARY_DELIVERY_SUCCESS, CREATE_SECONDARY_DELIVERY_FAIL} from '../actions/driverTypes.js'
import { OPEN_FIELD_CHANGE_DIALOG, OPEN_DRIVER_TRANSFER_DIALOG, OPEN_SECONDARY_DELIVERY_DIALOG } from '../actions/driverTypes.js';
import { GET_EXCEPTION_DETAILS, GET_EXCEPTION_DETAILS_SUCCESS, GET_EXCEPTION_DETAILS_FAIL } from '../actions/driverTypes.js';
import { EDIT_EXCEPTION, EDIT_EXCEPTION_SUCCESS, EDIT_EXCEPTION_FAIL } from '../actions/driverTypes.js';
import _ from 'lodash';
import { getImageDimensions } from '../utilities/common.js';
import { UPDATE_SHIPPING_STATUS, UPDATE_SHIPPING_STATUS_FAIL, UPDATE_SHIPPING_STATUS_SUCCESS } from '../actions/editOrderTypes.js';
//import { SHOW_ALERT_SNACK_BAR, HIDE_ALERT_SNACK_BAR } from '../actions/driverTypes.js';
import { GET_RETRY_POD, GET_RETRY_POD_SUCCESS, GET_RETRY_POD_FAIL } from "../actions/editOrderTypes.js";

import { GET_ORDER_POD, GET_ORDER_POD_SUCCESS, GET_ORDER_POD_FAIL } from "../actions/types";
import { GET_CUSTOMER_COMPLAIN_REASON, GET_CUSTOMER_COMPLAIN_REASON_FAIL, GET_CUSTOMER_COMPLAIN_REASON_SUCCESS } from '../actions/editOrderTypes.js';
import { GET_CUSTOMER_COMPLAIN, GET_CUSTOMER_COMPLAIN_SUCCESS, GET_CUSTOMER_COMPLAIN_FAIL } from '../actions/editOrderTypes.js';
import { GET_FAILED_REASON, GET_FAILED_REASON_SUCCESS, GET_FAILED_REASON_FAIL } from '../actions/editOrderTypes.js';

const initialState = {
    editException: [],
    editExceptionLoading: false,
    editExceptionError: false,
    
    getExceptionDetails: [],
    getExceptionDetailsLoading: false,
    getExceptionDetailsError: false,

    isLoading: false,
    basicInfoError: false,
    isError: false,

    //get the driver list
    warehouseList: [],
    exceptionList: [],
    nextTransitionList:[],
    nextTranistionLoadError: false,

    //
    isOpenModal: false,

    //get the detail driver info
    orderInfo: {},
    orderInfoLoading: false,
    orderInfoError: false,

    //get the detail driver info
    orderInfoDetail: [],
    orderInfoDetailLoading: false,
    orderInfoDetailError: false,

    orderSignature: {},
    orderSignatureLoading: false,
    orderSignatureError: false,
    
    orderUpdatStatus: "", 
    orderUpdateError: false,
    orderUpdateLoading: false,

    insertDriverOrderStatus: "",
    insertDriverOrderError: true,

    updateSccanStatusStatus: "",
    updateSccanStatusError: true,
    updateScanStatusLoading: false,  

    updateShippingStatusLoading: false,

    createSecondaryDeliveryStatus: "",
    createSecondaryDeliveryError: true,      
    createSecondaryDeliveryLoading: false,

    scndryDeliveryInfo:[],
    scndryDeliveryError: false,    
    
    openFieldChangeDialog: false,
    openDriverTransferDialog: false,
    openSecondaryDeliveryDialog: false,
    openAlertSnackbar: false,
    alertObject: {
        type: 'error',
        title: undefined,
        message: "",
        position: {
            vertical: "top",
            horizontal: "center"
        },
        duration: 5000
    },
    searchTypeList: [
        {label: 'Ant Parcel订单号', value: "tno"},
        {label: 'UNI订单号', value: "order_sn"},
        {label: 'order_id', value: "order_id"},
        {label: 'reference no', value: "reference"},
        {label: 'storage_info', value: "storage_info"}
    ],

    retryPod: [],
    retryPodLoading: false,
    retryPodError: false,

    getCustomerComplainReasonLoading: false,
    getCustomerComplainReason: [],
    getCustomerComplainReasonError: false,

    getCustomerComplainLoading: false,
    getCustomerComplain: [],
    getCustomerComplainError: false,

    failedReasonListLoading: false,
    failedReasonList: [],
    failedReasonError: false
}

export default function driverReducer(state = initialState, action) {
    switch(action.type) {
        case GET_FAILED_REASON:
            return {
                ...state,
                failedReasonListLoading: true,
                failedReasonListError: false,
            }
        case GET_FAILED_REASON_SUCCESS:
            return {
                ...state,
                failedReasonList: action.payload,
                failedReasonListLoading: false,
                failedReasonListError: false,
            }
        case GET_FAILED_REASON_FAIL:
            return {
                ...state,
                failedReasonList: initialState.failedReasonList,
                failedReasonListLoading: false,
                failedReasonListError: true,
            }  
        case GET_CUSTOMER_COMPLAIN:
            return {
                ...state,
                getCustomerComplainLoading: true,
                getCustomerComplainError: false,
            }
        case GET_CUSTOMER_COMPLAIN_SUCCESS:
            return {
                ...state,
                getCustomerComplain: action.payload,
                getCustomerComplainLoading: false,
                getCustomerComplainError: false,
            }
        case GET_CUSTOMER_COMPLAIN_FAIL:
            return {
                ...state,
                getCustomerComplain: initialState.getCustomerComplain,
                getCustomerComplainLoading: false,
                getCustomerComplainError: true,
            }  
        case GET_CUSTOMER_COMPLAIN_REASON:
            return {
                ...state,
                getCustomerComplainReasonLoading: true,
                getCustomerComplainReasonError: false,
            }
        case GET_CUSTOMER_COMPLAIN_REASON_SUCCESS:
            return {
                ...state,
                getCustomerComplainReason: action.payload,
                getCustomerComplainReasonLoading: false,
                getCustomerComplainReasonError: false,
            }
        case GET_CUSTOMER_COMPLAIN_REASON_FAIL:
            return {
                ...state,
                getCustomerComplainReasonLoading: false,
                getCustomerComplainReasonError: true,
            }  
        case GET_RETRY_POD:
            return {
                ...state,
                retryPodLoading: true,
                retryPodError: false,                
            }
        case GET_RETRY_POD_SUCCESS:
            return {
                ...state,
                retryPod: action.payload,
                retryPodLoading: false,
                retryPodError: false,           
            }
        case GET_RETRY_POD_FAIL:
            return {
                ...state,
                retryPodLoading: false,
                retryPodError: true,           
            }  
        case BASIC_INFO_LOAD:
            return {
                ...state,
                basicInfoError: false,            
            }
        case BASIC_INFO_LOAD_SUCCESS:
            return {
                ...state,
                warehouseList: action.payload.data.warehouses,  
                exceptionList: action.payload.data.exception, 
                basicInfoError: false,
            }
        case BASIC_INFO_LOAD_FAIL:
            return {
                ...state,
                basicInfoError: true,
            }    
        case ORDER_INFO_LOAD:
            return {
                ...state,
                orderInfoLoading: true,
                orderInfoError: false,            
            }
        case ORDER_INFO_LOAD_SUCCESS:
            return {
                ...state,
                orderInfo: action.payload.data,  
                orderInfoLoading: false,
                orderInfoError: false,
            }
        case ORDER_INFO_LOAD_FAIL:
            return {
                ...state,
                orderInfoLoading: false,
                orderInfoError: true,
            }    
        case ORDER_INFO_DETAIL_LOAD:
            return {
                ...state,
                orderInfoDetailLoading: true,
                orderInfoDetailError: false,            
            }
        case ORDER_INFO_DETAIL_LOAD_SUCCESS:
            return {
                ...state,
                orderInfoDetail: action.payload.data,  
                orderInfoDetailLoading: false,
                orderInfoDetailError: false,
            }
        case ORDER_INFO_DETAIL_LOAD_FAIL:
            return {
                ...state,
                orderInfoDetailLoading: false,
                orderInfoDetailError: true,
            }
        case ORDER_INFO_UPDATE:
            return {
                ...state,
                orderUpdateLoading: true,
                orderUpdatStatus: "",
                orderUpdateError: false,           
            }
        case ORDER_INFO_UPDATE_SUCCESS:
            return {
                ...state,
                orderUpdateLoading: false,
                orderUpdatStatus: action.payload.status, 
                orderUpdateError: false,                    
            }
        case ORDER_INFO_UPDATE_FAIL:
            return {
                ...state,
                orderUpdateLoading: false,
                orderUpdatStatus: action.payload.status, 
                orderUpdateError: true,                    
            }        
        case NEXT_TRANSITION_LOAD:
            return {
                ...state,
                nextTranistionLoadError: false,            
            }
        case NEXT_TRANSITION_LOAD_SUCCESS:
            return {
                ...state,
                nextTransitionList: action.payload.data,
                nextTranistionLoadError: false,
            }
        case NEXT_TRANSITION_LOAD_FAIL:
            return {
                ...state,
                nextTranistionLoadError: true,
            }                            
        case GET_ORDER_POD:
            return {
                ...state,
                orderSignature: initialState.orderSignature,
                orderSignatureLoading: true,
                orderSignatureError: false,                
            }
        case GET_ORDER_POD_SUCCESS:
            return {
                ...state,
                orderSignature: action.payload,
                orderSignatureLoading: false,
                orderSignatureError: false,           
            }
        case GET_ORDER_POD_FAIL:
            return {
                ...state,
                orderSignatureLoading: false,
                orderSignatureError: true,    
                orderSignature: {}
            }  
        case ORDER_SIGNATURE_PHOTO_UPDATE:
            return {
                ...state,
                orderSignatureUpdate: true,
                orderSignatureError: false,                
            }
        case ORDER_SIGNATURE_PHOTO_UPDATE_SUCCESS:
            return {
                ...state,
                orderSignatureUpdate: false,
                orderSignatureError: false,           
            }
        case ORDER_SIGNATURE_PHOTO_UPDATE_FAIL:
            return {
                ...state,
                orderSignatureUpdate: false,
                orderSignatureError: true,           
            }     
        case INSERT_DRIVER_ORDER:
            return {
                ...state,
                insertDriverOrderStatus: "",
                insertDriverOrderError: false,                
            }
        case INSERT_DRIVER_ORDER_SUCCESS:
            return {
                ...state,
                insertDriverOrderStatus: action.payload,
                insertDriverOrderError: false,           
            }
        case INSERT_DRIVER_ORDER_FAIL:
            return {
                ...state,
                insertDriverOrderStatus: "",
                insertDriverOrderError: true,           
            }   
        case UPDATE_SCAN_STATUS:
            return {
                ...state,
                updateSccanStatusStatus: "",
                updateSccanStatusError: false,          
                updateScanStatusLoading: true      
            }
        case UPDATE_SCAN_STATUS_SUCCESS:
            return {
                ...state,
                updateScanStatusLoading: false,
                updateSccanStatusStatus: action.payload,
                updateSccanStatusError: false,           
            }
        case UPDATE_SCAN_STATUS_FAIL:
            return {
                ...state,
                updateScanStatusLoading: false,
                updateSccanStatusStatus: "",
                updateSccanStatusError: true,           
            }                         
        case CREATE_SECONDARY_DELIVERY:
            return {
                ...state,
                createSecondaryDeliveryStatus: "",
                createSecondaryDeliveryError: false,
                createSecondaryDeliveryLoading: true,            
            }
        case CREATE_SECONDARY_DELIVERY_SUCCESS:
            return {
                ...state,
                createSecondaryDeliveryStatus: action.payload,
                createSecondaryDeliveryError: false,    
                createSecondaryDeliveryLoading: false       
            }
        case CREATE_SECONDARY_DELIVERY_FAIL:
            return {
                ...state,
                createSecondaryDeliveryStatus: "",
                createSecondaryDeliveryError: true, 
                createSecondaryDeliveryLoading: false          
            }                                     
        case OPEN_FIELD_CHANGE_DIALOG:
            return {
                ...state,
                openFieldChangeDialog: action.payload,
            }            
        case OPEN_DRIVER_TRANSFER_DIALOG:
            return {
                ...state,
                openDriverTransferDialog: action.payload,
            }                
        case OPEN_SECONDARY_DELIVERY_DIALOG:
            return {
                ...state,
                openSecondaryDeliveryDialog: action.payload,
            }
        case EDIT_ORDER_ADDRESS: 
            return {
                ...state,
                isLoading: true
            }
        case EDIT_ORDER_ADDRESS_SUCCESS:
            return {
                ...state,
                isLoading: false
            }
        case EDIT_ORDER_ADDRESS_FAIL:
            return {
                ...state,
                isLoading: false
            }
        case GET_EXCEPTION_DETAILS:
            return {
                ...state,
                getExceptionDetailsLoading: true
            }
        case GET_EXCEPTION_DETAILS_SUCCESS:
            return {
                ...state,
                getExceptionDetails: action.payload,
                getExceptionDetailsLoading: false
            }
        case GET_EXCEPTION_DETAILS_FAIL:
            return {
                ...state,
                getExceptionDetailsLoading: false,
                getExceptionDetailsError: action.payload
            }
        case EDIT_EXCEPTION:
            return {
                ...state,
                editExceptionLoading: true
            }
        case EDIT_EXCEPTION_SUCCESS:
            return {
                ...state,
                editException: action.payload,
                editExceptionLoading: false
            }
        case EDIT_EXCEPTION_FAIL:
            return {
                ...state,
                editExceptionLoading: false,
                editExceptionError: action.payload
            }
        case UPDATE_SHIPPING_STATUS:
            return {
                ...state,
                updateShippingStatusLoading: true
            }
        case UPDATE_SHIPPING_STATUS_SUCCESS:
            return {
                ...state,
                updateShippingStatusLoading: false
            }
        case UPDATE_SHIPPING_STATUS_FAIL:
            return {
                ...state,
                updateShippingStatusLoading: false
            }
        default: 
            return state
    }
}
